import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFun } from "../../utils/fetchFun";

const initialState = {
  allEntryTypes: []
}


export const fetchAllEntryTypes = createAsyncThunk(
  'user/fetchAllEntryTypes',
  async () => {
    try {
      const response = await fetchFun(`/api/v1/entryType`, "GET");
      if(!response.success){
                throw new Error("Entry types not found!")
            }
      // const response = await responseRaw.json();
      return response;
    } catch (error) {
      console.log("Error - /latestImportData", error)
    }
  }
)



export const commonDataSlice = createSlice({
    name: 'commonDataSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(fetchAllEntryTypes.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchAllEntryTypes.fulfilled, (state, action) => {
        state.isLoading = false
        state.allEntryTypes = action.payload.data
      })
      builder.addCase(fetchAllEntryTypes.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      
    },
  })

//   export const {latestImportedData} = commonDataSlice.actions;
  
  export default commonDataSlice;